import Vue from 'vue'
import App from './App.vue'

import store from './store'

import './assets/common.less'

import dataV from '@jiaminghi/data-view'

import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts

Vue.config.productionTip = false

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

Vue.use(dataV)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
